module.exports = __webpack_public_path__ + "static/media/eop-360x210.e2df7548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/adverts/eop-360x210.jpg
// module id = 66
// module chunks = 0